export default "__VITE_ASSET__B$Jn2KQ0__"